import { useEffect, useRef, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../data/api';

const PageTracker = () => {
  const location = useLocation();
  const lastPath = useRef('');

  const track = useCallback((pathname) => {
    trackPageView({
      path: pathname,
      referrer: document.referrer || '',
      title: document.title || '',
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (location.pathname === lastPath.current) return;
    lastPath.current = location.pathname;
    track(location.pathname);
  }, [location.pathname, track]);

  return null;
};

export default PageTracker;
